import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface TherapyModalityStats {
  therapy_modality_id: string;
  name_en: string;
  name_cn: string;
  practitioner_count: number;
  average_rating: number | null;
  total_sessions: number;
}

export const useTherapyModalityStats = () => {
  return useQuery({
    queryKey: ['therapy-modality-stats'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('therapy_modality_stats')
        .select('*');

      if (error) throw error;
      
      // Transform to ensure proper types
      return (data || []).map(item => ({
        therapy_modality_id: item.therapy_modality_id as string,
        name_en: item.name_en as string,
        name_cn: item.name_cn as string,
        practitioner_count: Number(item.practitioner_count) || 0,
        average_rating: item.average_rating ? Number(item.average_rating) : null,
        total_sessions: Number(item.total_sessions) || 0,
      })) as TherapyModalityStats[];
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
};

// Helper to get stats for a specific therapy
export const useTherapyStats = (therapyId: string) => {
  const { data: allStats, isLoading, error } = useTherapyModalityStats();
  
  const stats = allStats?.find(s => s.therapy_modality_id === therapyId);
  
  return {
    stats,
    isLoading,
    error,
  };
};
